// extracted by extract-css-chunks-webpack-plugin
module.exports = {"section":"help-modal__section___xS9Wb","text":"help-modal__text___2gyP_","header":"help-modal__header___1xOL5","link":"help-modal__link___361Qi","link-item":"help-modal__link-item___4WLaw","linkItem":"help-modal__link-item___4WLaw","link-icon":"help-modal__link-icon___3g3Uy","linkIcon":"help-modal__link-icon___3g3Uy","details":"help-modal__details___21lGz"};
    if(module.hot) {
      // 1768788182181
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  